import {
  Season as SharedSeason,
  SeasonStatus as SharedSeasonStatus,
  SEASON_STATUSES as SharedSeasonStatuses,
} from "shared/dist/types/Season";

export type SeasonStatus = SharedSeasonStatus;
export const SEASON_STATUSES = SharedSeasonStatuses;

export default interface Season extends SharedSeason {}